import React, { useEffect, useState } from "react";
import { api, formatMinutes, formatDateBR } from "../lib/api";
import { Trash2 } from "lucide-react";
import { Input } from "../components/ui/input";

export default function Historico() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    const r = await api.get("/study-sessions");
    setItems(r.data);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!confirm("Excluir este registro?")) return;
    await api.delete(`/study-sessions/${id}`);
    load();
  };

  const filtered = items.filter((it) =>
    !q || it.discipline_name.toLowerCase().includes(q.toLowerCase()) || (it.topic || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6 max-w-[1400px]">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display text-3xl font-extrabold">Histórico</h1>
        <Input placeholder="Buscar disciplina ou tópico" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm" />
      </div>

      <div className="rounded-2xl bg-card border border-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr className="text-left">
              <th className="p-3 font-semibold">Data</th>
              <th className="p-3 font-semibold">Disciplina</th>
              <th className="p-3 font-semibold">Tópico</th>
              <th className="p-3 text-center font-semibold">Tempo</th>
              <th className="p-3 text-center font-semibold">Acertos</th>
              <th className="p-3 text-center font-semibold">Erros</th>
              <th className="p-3 text-center font-semibold">Questões</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={8} className="p-8 text-center text-muted-foreground">Nenhum registro encontrado.</td></tr>
            )}
            {filtered.map((it) => (
              <tr key={it.id} className="border-t border-border hover:bg-muted/30">
                <td className="p-3">{formatDateBR(it.date)}</td>
                <td className="p-3 font-semibold">{it.discipline_name}</td>
                <td className="p-3 text-muted-foreground">{it.topic || "—"}</td>
                <td className="p-3 text-center">{formatMinutes(it.duration_minutes)}</td>
                <td className="p-3 text-center text-green-600 font-semibold">{it.correct}</td>
                <td className="p-3 text-center text-red-500 font-semibold">{it.wrong}</td>
                <td className="p-3 text-center">{it.questions}</td>
                <td className="p-3">
                  <button onClick={() => del(it.id)} className="text-red-500 hover:bg-red-50 p-1.5 rounded"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
